import { PropsWithChildren } from 'react';

import { cn } from '../lib';
import { FormMessage } from './form';

interface DashboardFormMessageProps {
  className?: string;
}
export const DashboardFormMessage = ({
  children,
  className,
}: PropsWithChildren<DashboardFormMessageProps>) => {
  return (
    <FormMessage className={cn('px-4 pb-2 pt-0.5 text-[13px]', className)}>
      {children}
    </FormMessage>
  );
};
